import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../../services/config';
import { CompartmentEndpoint } from '../../constants/compartment-endpoint';
import {
  CompartmentUserAssignmentURIParams,
  CompartmentUserDeassignmentURIParams,
  CompartmentUserListURIParams,
  CompartmentUserUpdateUserPermissionsURIParams,
} from '../../models';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { HubEndpoint } from '../../../hub/constants/hub-endpoint';
import { ListServerPaginationStateModel } from '../../../../../../common/models';
import { UserSelectionItem } from '../../../../../../container-components/users-selection-dialog';

@Injectable({
  providedIn: 'root',
})
export class CompartmentUserListService {
  constructor(private http: WrapperHttpService) {}

  getCompartmentAvailableUserList({
    hubId,
    compartmentId,
    searchCriteria,
  }: CompartmentUserListURIParams): Observable<ListServerPaginationStateModel<UserSelectionItem>> {
    const url =
      `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${CompartmentEndpoint.Users}${CompartmentEndpoint.Available}?` +
      getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<ListServerPaginationStateModel<UserSelectionItem>>(url);
  }

  getCompartmentAssignedUserList({
    hubId,
    compartmentId,
    searchCriteria,
  }: CompartmentUserListURIParams): Observable<ListServerPaginationStateModel<UserSelectionItem>> {
    const { size, page, ...filterView } = searchCriteria;
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${
      CompartmentEndpoint.Users
    }${CompartmentEndpoint.Assigned}${CompartmentEndpoint.Search}?${getQueryStringFromObject({
      page,
      size,
    })}`;
    return this.http.withLoading().post<ListServerPaginationStateModel<UserSelectionItem>>(url, filterView);
  }

  assignUsers({ hubId, compartmentId, users }: CompartmentUserAssignmentURIParams): Observable<UserSelectionItem> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${CompartmentEndpoint.Users}`;
    return this.http.withLoading().post<UserSelectionItem>(url, users);
  }

  deassignUsers({ hubId, compartmentId, users }: CompartmentUserDeassignmentURIParams): Observable<UserSelectionItem> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${CompartmentEndpoint.Users}`;
    return this.http.withLoading().delete<UserSelectionItem>(url, {
      body: users,
    });
  }

  updateUser({
    hubId,
    compartmentId,
    user,
  }: CompartmentUserUpdateUserPermissionsURIParams): Observable<UserSelectionItem> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}${CompartmentEndpoint.Users}/${user.id}${CompartmentEndpoint.CarrierPermissions}`;

    return this.http.withLoading().put<UserSelectionItem>(url, {
      organizationId: user.organizationId,
      carrierBoUserPermissions: user.carrierBoUserPermissions,
    });
  }
}
